module.exports = __webpack_public_path__ + "img/prize.5faab5e7.png";